import { Link, useLocation } from 'react-router-dom';
import { companyInfo } from '../data';

export default function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <footer className="border-t border-wine-900/60 bg-wine-950">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          
          {/* Brand & Concept */}
          <div className="space-y-4">
            {!isHomePage && (
              <>
                <div className="flex items-center gap-3">
                  <img
                    src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=95,format=auto/assets/5ea68c18-23db-4ec0-b08f-b9fe5fda53ae/66995ea1-67a0-4d2a-86bd-857f23dff781.png"
                    alt="La Fable Logo"
                    className="h-24 sm:h-28 md:h-32 w-auto object-contain filter drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]"
                  />
                </div>
                <p className="font-sans text-sm font-light text-sand-200/80 leading-relaxed max-w-sm">
                  La Fable is La Fontaine's wine bar – a natural, elegant extension of Denmark's oldest jazz club. Here, world-class wine, hospitality, and a vibrant atmosphere meet.
                </p>
              </>
            )}
            <div className="flex flex-wrap items-center gap-3 pt-2">
              <a
                href={companyInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 border border-sand-300/30 bg-transparent text-sand-300 text-xs tracking-wider uppercase hover:border-sand-300 hover:bg-white/5 transition-all duration-300 inline-flex items-center gap-2"
              >
                <i className="fa-brands fa-instagram" />
                @lafablecph
              </a>
              <a
                href={companyInfo.laFontaineInstagram}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 border border-sand-300/30 bg-transparent text-sand-300 text-xs tracking-wider uppercase hover:border-sand-300 hover:bg-white/5 transition-all duration-300 inline-flex items-center gap-2"
              >
                <i className="fa-brands fa-instagram" />
                @lafontainecph
              </a>
            </div>
            <div className="pt-4 border-t border-wine-900/40">
              <span className="font-sans text-xs font-light text-sand-200/50 block">
                Part of Copenhagen's historic cultural heritage.
              </span>
              <a
                href={companyInfo.laFontaineUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="font-sans text-xs font-medium text-sand-300 hover:underline mt-1 inline-block"
              >
                Visit Denmark's oldest jazz club, La Fontaine →
              </a>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg tracking-wide text-sand-300">
              Opening Hours
            </h3>
            <div className="space-y-4 font-sans text-sm font-light text-sand-200/80">
              <div>
                <h4 className="font-serif text-sm font-medium text-sand-100 mb-1">La Fable pop-up</h4>
                <ul className="space-y-1 text-xs">
                  <li className="flex justify-between border-b border-wine-900/40 pb-1">
                    <span>Wed-Sun</span>
                    <span className="font-normal text-sand-100">From ~15:00 - Midnight</span>
                  </li>
                </ul>
                <p className="text-[10px] text-sand-200/50 italic mt-1">
                  * Weather permitting
                </p>
              </div>
              <div className="border-t border-wine-900/40 pt-3 space-y-2">
                <h4 className="font-serif text-sm font-medium text-sand-100 mb-1">La Fontaine</h4>
                <ul className="space-y-1 text-xs">
                  <li className="flex justify-between border-b border-wine-900/40 pb-1">
                    <span>Mon-Thu</span>
                    <span className="font-normal text-sand-100">20:00-03:00</span>
                  </li>
                  <li className="flex justify-between border-b border-wine-900/40 pb-1">
                    <span>Fri-Sat</span>
                    <span className="font-normal text-sand-100">20:00-05:00</span>
                  </li>
                  <li className="flex justify-between border-b border-wine-900/40 pb-1">
                    <span>Sun</span>
                    <span className="font-normal text-sand-100">20:00-03:00</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact & Info */}
          <div className="space-y-4">
            <h3 className="font-serif text-lg tracking-wide text-sand-300">
              Contact Us
            </h3>
            <ul className="space-y-3 font-sans text-sm font-light text-sand-200/80">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-sand-300 mt-1" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-sand-300" />
                <a
                  href={`tel:${companyInfo.phone.replace(/\s+/g, '')}`}
                  className="hover:text-sand-300 transition-colors whitespace-nowrap"
                >
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-sand-300" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="hover:text-sand-300 transition-colors whitespace-nowrap"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="mt-12 border-t border-wine-900/40 pt-8 text-center font-sans text-xs font-light text-sand-200/40">
          <p>© {new Date().getFullYear()} {companyInfo.name}. All rights reserved.</p>
          <p className="mt-1 text-[10px]">Created with love for wine, jazz, and hospitality.</p>
        </div>
      </div>
    </footer>
  );
}
